import BaseComponent from "../../../../baseComponent.js";
import React from "react";
import InternalEvent from "../../../../../core/constants/internalEvent.js";
import WidgetService from "../../../../../core/services/widgetService.js";

import Color from "../../../add-widget/legend-config/color.jsx";
import Opacity from "../../../add-widget/legend-config/opacity.jsx";
import CheckBox from "../../../../../components/common/check-box/checkBox.jsx"
import CustomColor from "../../../add-widget/legend-config/customColor.jsx";
import Modal from "../../../../common/modal.jsx";
import styles from "./legend-edit.scss";
import DashboardService from "../../../../../core/services/dashboardService";

export default class LegendEdit extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      legends: JSON.parse(JSON.stringify(this.props.legends)),
      applyToAll: false
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      legends: JSON.parse(JSON.stringify(nextProps.legends)),
      applyToAll: false
    });
  }

  /**
   * Applies legend changes globally(all dashboards).
   * Legends that have the same legend label will be affected
   * @param oldLegend
   * @param newLegend
   */
  applyChangeToAllDashboard(oldLegend, newLegend) {
    const currentDashboardId = DashboardService.getCurrentDashboardId();
    DashboardService.getAllDashboards()
      .then(dashboards => {
        const promises = [];
        dashboards.forEach(d => {
          promises.push(DashboardService.findDashboardStateByDashboardId(d.persistenceId));
        });
        return Promise.all(promises);
      })
      .then(dashboardStates => {
        dashboardStates.forEach(ds => {
          let shouldUpdate = false;

          const newState = ds.dashboardState.map(state => {
            const legendGroups = this.groupLegends(state.widgetModel.legends);
            for (let groupId in legendGroups) {
              let shouldUpdateGroup = false;

              legendGroups[groupId].forEach(l => {
                if (l.parameters.legendLabel === oldLegend.parameters.legendLabel) {
                  shouldUpdateGroup = true;
                }
              });

              if (shouldUpdateGroup) {
                legendGroups[groupId].forEach(legendInGroup => {
                  legendInGroup.parameters.legendColor = newLegend.parameters.legendColor;
                  legendInGroup.parameters.chartTypeParameters["fillOpacity"] = newLegend.parameters.chartTypeParameters["fillOpacity"];
                  legendInGroup.parameters.chartTypeParameters["strokeOpacity"] = newLegend.parameters.chartTypeParameters["strokeOpacity"];
                  if (legendInGroup.parameters.legendLabel === oldLegend.parameters.legendLabel) {
                    legendInGroup.parameters.legendLabel = newLegend.parameters.legendLabel;
                  }
                });
                shouldUpdate = true;
              }
            }

            if (ds.dashboard === currentDashboardId) {
              WidgetService.updateWidgetLegends(state.widgetModel.id, state.widgetModel.legends);
              this.publish(InternalEvent.Dashboard.CHART_LEGEND_UPDATED, {
                widgetId: state.widgetModel.id,
                updateState: false
              });
            }
            return state;
          });

          if (shouldUpdate) {
            DashboardService.updateDashboardState(ds.dashboard, ds.persistenceId, newState);
          }
        });
      });
  }

  confirm() {
    if (this.state.applyToAll) {
      const newLegend = JSON.parse(JSON.stringify(this.state.legends[0]));
      this.applyChangeToAllDashboard(this.props.legends[0], newLegend);
    } else {
      WidgetService.updateWidgetLegends(this.props.widgetId, JSON.parse(JSON.stringify(this.state.legends)));
      this.publish(InternalEvent.Dashboard.CHART_LEGEND_UPDATED, {widgetId: this.props.widgetId});
    }
    this.refs.modal.hide();
  }

  groupLegends(legends) {
    const legendsGroup = {};
    legends.forEach(legend => {
      const groupId = legend.parameters.groupId;
      if (legendsGroup.hasOwnProperty(groupId)) {
        legendsGroup[groupId].push(legend);
      } else {
        legendsGroup[groupId] = [legend];
      }
    });
    return legendsGroup;
  }

  handleLegendChange(propertyName, value) {
    const newLegends = this.state.legends.map((legend, index) => {
      if (propertyName === "fillOpacity" || propertyName === "strokeOpacity") {
        legend.parameters.chartTypeParameters["fillOpacity"] = value;
        legend.parameters.chartTypeParameters["strokeOpacity"] = value;
      } else if (propertyName === "legendLabel" && index !== 0) {
        return legend;
      } else {
        legend.parameters[propertyName] = value;
      }
      return legend;
    });

    this.setState({
      legend: newLegends
    });
  }

  handleCheckboxClick(value) {
    this.setState({
      applyToAll: !value
    });
  }

  isTechnicalChartIndicator() {
    const indicators = ['SMA', 'MACD', 'RSI'];
    const legend = this.state.legends[0];
    return indicators.indexOf(legend.id) > -1;
  }

  isSMAIndicator() {
    const legend = this.state.legends[0];
    return legend.id === 'SMA' || legend.parameters.legendLabel === "SMA";
  }

  show() {
    this.refs.modal.show();
  }

  render() {
    const legend = this.state.legends[0];
    const {legendLabel, legendColor} = legend.parameters;
    return (
      <Modal ref="modal" width={500} confirm={this.confirm}>
        <h5>Edit legend</h5>
        <div className={styles.content} ref="content">
          <div className={styles.title}>Label</div>
          <div className={styles.wrapper}>
            <input className={styles.tickFormatInput} type="text" value={legendLabel} name="format"
                   onChange={e => this.handleLegendChange('legendLabel', e.target.value)}/>
          </div>
          <div>
            <div className={styles.title}>Color</div>
            <div className={styles.colors}>
              <Color label={false} color={legend.parameters.legendColor}
                     opacity={legend.parameters.chartTypeParameters.strokeOpacity}
                     onLegendChange={this.handleLegendChange}/>
              <CustomColor color={legend.parameters.legendColor}
                           onLegendChange={this.handleLegendChange}/>
            </div>
          </div>
          <div>
            <div className={styles.title}>Opacity</div>
            <div className={styles.opacity}>
              <Opacity label={false} chartType={legend.parameters.chartType}
                       opacity={legend.parameters.chartTypeParameters}
                       onLegendChange={this.handleLegendChange}/>
            </div>
          </div>
          <div className={styles.wrapper}>
            <CheckBox text="Apply to All Dashboards" value={this.state.applyToAll}
                      onChange={(value) => this.handleCheckboxClick(value)}/>
          </div>
        </div>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/timeseries-chart/legend/legendEdit.jsx